import {
  Component,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Input,
  ViewChild
} from "@angular/core";
import { get, isEmpty, join } from 'lodash';
import { NetworkSettingsService } from "../../../wizard/controls/network.settings/network.settings.service";
import { REMOVED } from "../../services/base.wizard.step";
import { NgForm, NgModel } from "@angular/forms";
import { CommonRegEx } from "@nrwl/common-lib";

@Component({
  selector: "network-settings",
  templateUrl: "./network.settings.template.html",
  styleUrls: ['./network.settings.style.scss']
})
export class NetworkSettingsComponent implements OnChanges {
  networkSettingsService: NetworkSettingsService;

  @ViewChild('currentForm') form: NgForm;

  @Input() parentOutput: any; // "<"
  @Input() step: any; // <
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();
  @Input() key: string; // @

  @ViewChild('addressInput') proxyAddressControl: NgModel;
  @ViewChild('subnetMaskInput') subnetMaskControl: NgModel;
  @ViewChild('gatewayInput') gatewayControl: NgModel;
  @ViewChild('dnsInput') dnsControl: NgModel;


  IP_REGEX: RegExp = CommonRegEx.IP_REGEX;
  SUBNET_MASK_REGEX: RegExp = CommonRegEx.SUBNET_MASK_REGEX;


  // network settings are applicable to virtual agents only
  isVirtualAgentSelected = false;
  dynamicIPselected = true;
  staticIPselected = false;
  loadAttempt = 0; // 0 - not yet, 1 - in progress, 2 - done (either OK or failure)

  address: any = null;
  subnetMask: any = null;
  gateway: any = null;
  dns: any = null;

  constructor(
    networkSettingsService: NetworkSettingsService
  ) {
    this.networkSettingsService = networkSettingsService;
  }

  selectDynamicIP() {
    this.dynamicIPselected = true;
    this.staticIPselected = false;
    this.fireUpdate();
  }

  selectStaticIP() {
    this.dynamicIPselected = false;
    this.staticIPselected = true;
    this.fireUpdate();
  }

  updates() {
    this.fireUpdate();
  }

  mustBePresented() {
    return this.isVirtualAgentSelected;
  }

  _recalculateSelectionState() {
    // restore 'selection' if user clicked 'Back' to revisit the page
    const knownChoice = this.parentOutput[this.key];
    if (knownChoice && knownChoice !== REMOVED) {
      this.dynamicIPselected = false;
      this.staticIPselected = true;
      this.address = knownChoice.ip;
      this.subnetMask = knownChoice.netmask;
      this.gateway = knownChoice.gateway;
      this.dns = join(knownChoice.dns, "\n");
    }
  }

  /**
   * Please note this event is triggered only for one-way bindings (<)
   */
  ngOnChanges(changes: SimpleChanges) {
    setTimeout(
      () => {
        this.fireUpdate();
        if (this.loadAttempt === 0) {
          this.loadAttempt = 1;
          const agentType = get(this.parentOutput, "agentType.id", "");
          this.isVirtualAgentSelected = agentType === "virtual";
          this._recalculateSelectionState();
          this.fireUpdate();
          this.loadAttempt = 2;
        }
      },
      0
    );
  }

  _makeOutput() {
    if (!this.isVirtualAgentSelected) {
      // in case page was loaded with incorrect agent, make sure we reset data in output
      return null;
    }
    if (this.dynamicIPselected) {
      return null;
    }
    return {
      dns: this.networkSettingsService.parseDns(this.dns),
      gateway: this.gateway,
      ip: this.address,
      netmask: this.subnetMask
    };
  }

  fireUpdate() {
    setTimeout(
      () => {
    const dataOutput = this._makeOutput();
    this.onUpdate.emit({ key: this.key,
value: dataOutput,
isValid:this._checkValidData(dataOutput) });
      },0);
  }

  _checkValidData(dataOutput) {
    let isValid = true;
    if (dataOutput) {
      isValid = isValid && !isEmpty(dataOutput.ip);
      isValid = isValid && !isEmpty(dataOutput.netmask);
      isValid = isValid && !isEmpty(dataOutput.gateway);
      isValid = isValid && !isEmpty(dataOutput.dns);
      isValid = isValid && this.proxyAddressControl.control.valid && this.subnetMaskControl.control.valid
                && this.gatewayControl.control.valid;
      return isValid;
    }
  }
}
